/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_External_Booking_Edit_Extra_Price_Per_Day_PersonInputs */

const en_admin_external_booking_edit_extra_price_per_day_person = /** @type {(inputs: Admin_External_Booking_Edit_Extra_Price_Per_Day_PersonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`per person, per day`)
};

const de_admin_external_booking_edit_extra_price_per_day_person = /** @type {(inputs: Admin_External_Booking_Edit_Extra_Price_Per_Day_PersonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`pro Person, pro Tag`)
};

const es_admin_external_booking_edit_extra_price_per_day_person = /** @type {(inputs: Admin_External_Booking_Edit_Extra_Price_Per_Day_PersonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`por persona, por día`)
};

const fr_admin_external_booking_edit_extra_price_per_day_person = /** @type {(inputs: Admin_External_Booking_Edit_Extra_Price_Per_Day_PersonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`par personne, par jour`)
};

const nl_admin_external_booking_edit_extra_price_per_day_person = /** @type {(inputs: Admin_External_Booking_Edit_Extra_Price_Per_Day_PersonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`per persoon, per dag`)
};

/** @type {(inputs: Admin_External_Booking_Edit_Extra_Price_Per_Day_PersonInputs) => LocalizedString} */
const it_admin_external_booking_edit_extra_price_per_day_person = en_admin_external_booking_edit_extra_price_per_day_person;

/** @type {(inputs: Admin_External_Booking_Edit_Extra_Price_Per_Day_PersonInputs) => LocalizedString} */
const pt_br2_admin_external_booking_edit_extra_price_per_day_person = en_admin_external_booking_edit_extra_price_per_day_person;

/** @type {(inputs: Admin_External_Booking_Edit_Extra_Price_Per_Day_PersonInputs) => LocalizedString} */
const pl_admin_external_booking_edit_extra_price_per_day_person = en_admin_external_booking_edit_extra_price_per_day_person;

/** @type {(inputs: Admin_External_Booking_Edit_Extra_Price_Per_Day_PersonInputs) => LocalizedString} */
const hu_admin_external_booking_edit_extra_price_per_day_person = en_admin_external_booking_edit_extra_price_per_day_person;

/** @type {(inputs: Admin_External_Booking_Edit_Extra_Price_Per_Day_PersonInputs) => LocalizedString} */
const ro_admin_external_booking_edit_extra_price_per_day_person = en_admin_external_booking_edit_extra_price_per_day_person;

/**
* | output |
* | --- |
* | "per person, per day" |
*
* @param {Admin_External_Booking_Edit_Extra_Price_Per_Day_PersonInputs} inputs
* @param {{ locale?: "en" | "de" | "es" | "fr" | "nl" | "it" | "pt-BR" | "pl" | "hu" | "ro" }} options
* @returns {LocalizedString}
*/
const admin_external_booking_edit_extra_price_per_day_person = /** @type {((inputs?: Admin_External_Booking_Edit_Extra_Price_Per_Day_PersonInputs, options?: { locale?: "en" | "de" | "es" | "fr" | "nl" | "it" | "pt-BR" | "pl" | "hu" | "ro" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_External_Booking_Edit_Extra_Price_Per_Day_PersonInputs, { locale?: "en" | "de" | "es" | "fr" | "nl" | "it" | "pt-BR" | "pl" | "hu" | "ro" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_admin_external_booking_edit_extra_price_per_day_person(inputs)
	if (locale === "de") return de_admin_external_booking_edit_extra_price_per_day_person(inputs)
	if (locale === "es") return es_admin_external_booking_edit_extra_price_per_day_person(inputs)
	if (locale === "fr") return fr_admin_external_booking_edit_extra_price_per_day_person(inputs)
	if (locale === "nl") return nl_admin_external_booking_edit_extra_price_per_day_person(inputs)
	if (locale === "it") return it_admin_external_booking_edit_extra_price_per_day_person(inputs)
	if (locale === "pt-BR") return pt_br2_admin_external_booking_edit_extra_price_per_day_person(inputs)
	if (locale === "pl") return pl_admin_external_booking_edit_extra_price_per_day_person(inputs)
	if (locale === "hu") return hu_admin_external_booking_edit_extra_price_per_day_person(inputs)
	return ro_admin_external_booking_edit_extra_price_per_day_person(inputs)
});
export { admin_external_booking_edit_extra_price_per_day_person as "admin.external_booking_edit.extra_price_per_day_person" }